import { render, staticRenderFns } from "./PlainTextBuilder.vue?vue&type=template&id=3f834ec0&"
import script from "./PlainTextBuilder.vue?vue&type=script&lang=js&"
export * from "./PlainTextBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports